import React, { useEffect, useState } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import '../../../../components/SplitActions/style.scss';
import { Typography, useTheme, Tab, Tabs, Box, IconButton, Stack, Accordion, AccordionSummary, DialogActions, Button, Tooltip } from '@mui/material';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import moment from 'moment';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import FleetDetails from './FleetDetails';
import AddVoyage from './AddVoyage';
import AddEditShip from './AddShip';
import EditShip from './EditShip';
import { useSelector } from 'react-redux';
import TabPanel from '../../../../components/TabPanel';
import Report from './Report';
import format from '../../../../assets/images/format.svg';
import card from '../../../../assets/images/card.svg';
import { useTranslation } from 'react-i18next';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FleetDetailsTabPanel({ isDrawerOpen, toggleDrawer, init, ship, isArchived }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  let source = CancelToken.source();

  const {t} = useTranslation()

  const { userId, companyDetails } = useSelector((state) => state.auth);

  const [shipDetails, setShipDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openAddEditContacts, setOpenAddEditContacts] = useState(false);
  const [tabIndexValue, setValue] = React.useState(0);
  const [openAddVoyage, setOpenAddVoyage] = useState(false);
  const [openEditShip, setOpenEditShip] = useState(false);

  useEffect(() => {
    if (ship) {
      getShipDetails();
    } else {
      setShipDetails(null);
    }
  }, [ship]);

  const getShipDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(`fleet/ship/${ship?._id}`);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setShipDetails(data.response);
      }
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // setCompanyManagementList([]);
    // setPayload((prev) => ({ ...prev, limt: 10, paginationPage: 0, page: 1, filter: null }));
  };

  return (
    <Stack
      flex={1}
      className={!isDrawerOpen ? 'shrinkside flex' : 'expandside flex'}
    >
      <div className="absolute ml-[-18px]">
        <IconButton
          className="!shadow-2xl"
          sx={{ boxShadow: 'rgba(0, 0, 0, 0.5) 1px 5px 10px !important', '&:hover': { width: '40px !important', marginLeft: '-20px' } }}
          style={{
            color: '#00000',
            width: '20px',
            paddingTop: '10px',
            height: '40px',
            zIndex: 999,
            backgroundColor: '#FFFF',
            borderRadius: '10px 0px 0px 10px',
          }}
          onClick={() => {
            toggleDrawer();
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Stack
        flex={1}
        style={{ background: '#FFFF', border: !isDrawerOpen ? 'none' : '1px solid #14285A1A', width: !isDrawerOpen ? '0px' : '500px', borderRadius: 1 }}
        onClose={() => {
          toggleDrawer();
        }}
      >
        {isDrawerOpen ? (
          <>
            {shipDetails?.length <= 0 && !loading && <NoDataFound />}
            {loading && (
              <Stack
                flex={1}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <ActivityIndicator />
              </Stack>
            )}
            {!loading && (
              <>
                <Stack flex={1}>
                  <Box
                    sx={{
                      display: 'flex',
                      borderBottom: 1,
                      border: 'none',
                      color: 'rgba(255, 255, 255, 1)',
                      borderRadius: '5px 5px 0px 0px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Stack
                      style={{ justifyContent: 'center' }}
                      className="px-[16px]"
                    >
                      <Typography
                        className="fw-medium ff-Roboto !capitalize"
                        color={text}
                      >
                        {t('Details')}
                      </Typography>
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                      >
                        <Typography
                          className="fw-medium ff-Roboto fs-10 !capitalize"
                          color={textLight}
                        >
                          {t('Last modified')}
                        </Typography>
                        {/* <img src={format} /> */}
                        <Typography
                          className="fw-medium ff-Roboto fs-10 !ml-[6px]"
                          color={text}
                        >
                          {moment(shipDetails?.modifiedOn).format('DD-MMM-YYYY')}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Tabs
                      sx={{
                        '& .MuiTabs-indicator': {
                          backgroundColor: '#FFCC00 !important',
                        },
                      }}
                      value={tabIndexValue}
                      onChange={handleChange}
                    >
                      <Tab
                       sx={{ minHeight: '56px' }}
                        className="text-#14285A fw-medium ff-Roboto !uppercase"
                        label={t('Details')}
                        icon={
                          <img
                            src={card}
                            style={{ width: '16px', height: '12px' }}
                          />
                        }
                        iconPosition="start"
                        {...a11yProps(0)}
                      />
                      <Tab
                       sx={{ minHeight: '56px' }}
                        className="!uppercase !text-#14285A fw-medium ff-Roboto"
                        label={t('Reports')}
                        icon={
                          <img
                            src={format}
                            style={{ width: '16px', height: '12px' }}
                          />
                        }
                        iconPosition="start"
                        {...a11yProps(1)}
                      />
                    </Tabs>
                  </Box>
                  <Stack style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }} />
                  {tabIndexValue === 0 && (
                    <TabPanel
                      className="flex flex-col flex-1 min-h-0"
                      value={tabIndexValue}
                      index={0}
                    >
                      <FleetDetails
                        setOpenAddVoyage={() => setOpenAddVoyage(true)}
                        setOpenEditShip={() => setOpenEditShip(true)}
                        isLoading={loading}
                        details={shipDetails}
                        isArchived={isArchived}
                      />
                    </TabPanel>
                  )}
                  {tabIndexValue === 1 && (
                    <TabPanel
                      className="flex flex-col flex-1 min-h-0"
                      value={tabIndexValue}
                      index={1}
                    >
                      <Report data={shipDetails}/>
                    </TabPanel>
                  )}
                </Stack>
              </>
            )}
          </>
        ) : null}
      </Stack>
      {openAddVoyage && (
        <AddVoyage
          modelOpen={openAddVoyage}
          onModelHandleClose={(event) => {
            if (event) {
              // getShipDetails();
              // init();
            }
            setOpenAddVoyage(false);
          }}
          partyInfo={companyDetails}
          ship={shipDetails}
        />
      )}
      {openEditShip && (
        <EditShip
          modelOpen={openEditShip}
          onModelHandleClose={(event) => {
            if (event) {
              getShipDetails();
              init();
            }
            setOpenEditShip(false);
          }}
          ship={shipDetails}
          partyInfo={companyDetails}
        />
      )}
    </Stack>
  );
}
